import React, { Component } from 'react'
import { connect } from 'react-redux'
import JobsForm from './JobsForm'
import { updateInMemoryJob, saveJob } from './jobs-reducer'
import KeyboardBackspaceIcon from 'material-ui-icons/KeyboardBackspace'
import { Link } from 'react-router-dom'
import Button from 'material-ui/Button'

class JobsFormContainer extends Component {
  render () {
    const {
      inMemoryJob,
      successMsg,
      saveJob,
      updateInMemoryJob,
      isJobsRequestOngoing,
      locations
    } = this.props

    /**
     * This is used to handle any changes from our create jobs creation/assignment form
     */
    const handleFormChange = (field, value) => {
      updateInMemoryJob({ [field]: value })
    }

    return (
      <div>
        <h4> Create Job Form</h4>
        <Link to='/jobs'>
          <Button color='primary'>
            <KeyboardBackspaceIcon /> View created jobs
          </Button>
        </Link>

        <JobsForm
          title={inMemoryJob.title}
          stops={inMemoryJob.stops}
          driver={inMemoryJob.driver}
          onFormChange={handleFormChange}
          onJobSave={() => saveJob()}
          successMsg={successMsg}
          isJobsRequestOngoing={isJobsRequestOngoing}
          locations={locations}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ jobs, locations: { locations } }) => ({
  isJobsRequestOngoing: jobs.isJobsRequestOngoing,
  successMsg: jobs.successMsg,
  inMemoryJob: jobs.inMemoryJob,
  locations
})

const mapDispatchToProps = {
  updateInMemoryJob,
  saveJob
}

export default connect(mapStateToProps, mapDispatchToProps)(JobsFormContainer)



// WEBPACK FOOTER //
// ./src/jobs/JobsFormContainer.js